import type { ReactNode } from "react"
import { createPortal } from "react-dom"

/**
 * `next/head` shim — React Router implementation (NEX-248 Phase C).
 *
 * Resolved ONLY under Vite via the `next/head` alias. Portals its children
 * (`<title>`, `<meta>`, `<link>`, ...) straight into `document.head`. React
 * keeps them in sync with the component tree and removes them on unmount, which
 * covers the per-page head tags the app sets. No SSR concerns — the SPA is
 * fully client-rendered.
 *
 * Named `NextHeadShim`, not `Head`: `common/head/Head.tsx` exports the `Head`
 * the app actually writes, and it wraps THIS module (`import NextHead from
 * "@/common/vite-shims/next/head"`). Two things called `Head`, one importing
 * the other, is how a reader ends up editing the wrong one.
 */
export default function NextHeadShim({ children }: { children: ReactNode }) {
  if (typeof document === "undefined") return null
  return createPortal(children, document.head)
}
